import { RadioGroup } from '@cimplico/components';

type VerticalRadioInputProps = {
    title: string;
    description: string;
    optionOneLabel: string;
    optionTwoLabel: string;
    isDisabledOptionOne?: boolean;
    isDisabledOptionTwo?: boolean;
    value?: string;
    onValueChange: (value: string) => void;
};

function VerticalRadioInput({
    title,
    description,
    optionOneLabel,
    optionTwoLabel,
    isDisabledOptionOne,
    isDisabledOptionTwo,
    value,
    onValueChange,
}: VerticalRadioInputProps): JSX.Element {
    return (
        <div className="flex flex-col">
            <label className="text-sm font-medium text-gray-700 mb-1">{title}</label>
            <span className="text-xs text-gray-500 mb-4">{description}</span>
            <RadioGroup
                groupName="inputType"
                options={[
                    {
                        label: optionOneLabel,
                        value: optionOneLabel.toLocaleLowerCase(),
                        disabled: isDisabledOptionOne,
                    },
                    {
                        label: optionTwoLabel,
                        value: optionTwoLabel.toLocaleLowerCase(),
                        disabled: isDisabledOptionTwo,
                    },
                ]}
                value={value}
                onChange={(e): void => onValueChange(e.target.value)}
            />
        </div>
    );
}

export default VerticalRadioInput;
